// =====================================================
// 📁 POSProductItem.tsx
// =====================================================

import { ProductPanelItem } from '../../../../../types/productpanel/ProductPanelItem';

import POSProductCardItem from './POSProductCardItem';

import POSProductListItem from './POSProductListItem';

interface Props {
  product: ProductPanelItem;

  mode?: 'card' | 'list';

  quantity?: number;

  disabled?: boolean;

  onAddToCart?: (product: ProductPanelItem) => void;

  onIncreaseQuantity?: (product: ProductPanelItem) => void;

  onDecreaseQuantity?: (product: ProductPanelItem) => void;
}

const POSProductItem = ({
  product,

  mode = 'card',

  quantity,

  disabled,

  onAddToCart,

  onIncreaseQuantity,

  onDecreaseQuantity,
}: Props) => {
  // =====================================================
  // 🔹 List Mode
  // =====================================================
  if (mode === 'list') {
    return (
      <POSProductListItem
        product={product}
        quantity={quantity}
        disabled={disabled}
        onAddToCart={onAddToCart}
        onIncreaseQuantity={onIncreaseQuantity}
        onDecreaseQuantity={onDecreaseQuantity}
      />
    );
  }

  // =====================================================
  // 🔹 Card Mode
  // =====================================================
  return (
    <POSProductCardItem
      product={product}
      quantity={quantity}
      disabled={disabled}
      onAddToCart={onAddToCart}
      onIncreaseQuantity={onIncreaseQuantity}
      onDecreaseQuantity={onDecreaseQuantity}
    />
  );
};

export default POSProductItem;
